import _ from 'lodash';
import { SET_EDITOR_SELECTED_NODE, SET_EDITABLE_STATE } from 'client/constants/actions';
import { SELECTION_TYPES } from 'client/components/common/SelectionHint/utils';
import initialState from './initial-state';

export default function editorReducer(state = initialState, action): typeof initialState {
	if (action.type === SET_EDITOR_SELECTED_NODE) {
		const { type, data, isMultiSelect } = action.payload;

		if (!type) {
			return { ...state, selection: initialState.selection };
		}

		const selection = { ...state.selection };
		const id = _.get(data, 'id');

		if (type === SELECTION_TYPES.hovered) {
			const nextData = id ? { [id]: data } : null;
			selection[type] = { ...initialState.selection[type], ...nextData };
		}

		if (type === SELECTION_TYPES.clicked && isMultiSelect) {
			if (_.isArray(data)) {
				// update multiple selected nodes in a single bunch
				data.forEach(selectedNode => {
					selection[type][selectedNode.id] = selectedNode;
				});
			} else if (selection[type][id]) {
				delete selection[type][id];
			} else {
				selection[type][id] = data;
			}
		} else if (type === SELECTION_TYPES.clicked) {
			selection[type] = { [id]: data };
		}

		return {
			...state,
			selection,
		};
	}

	if (action.type === SET_EDITABLE_STATE) {
		return {
			...state,
			state: {
				...state.state,
				...action.payload,
			},
		};
	}

	return state;
}
